import { createAction } from '@reduxjs/toolkit';
import { validatePayload, requiredNonEmptyString, requiredEmptyAllowedString, } from '../../utils/validate-payload.js';
export const querySetDefinition = {
    id: requiredNonEmptyString,
    query: requiredEmptyAllowedString,
};
export const registerQuerySetQuery = createAction('querySet/register', (payload) => validatePayload(payload, querySetDefinition));
export const updateQuerySetQuery = createAction('querySet/update', (payload) => validatePayload(payload, querySetDefinition));
